import React from 'react';
import { HeadingTagLineText, HeadingText } from './style';

export default function GenericHeadingText({ className = '', title, tagLine }: any) {
    return (
        <div className={'flex-column ' + className}>
            <HeadingText title={title}>{title}</HeadingText>
            {tagLine && <HeadingTagLineText>{tagLine}</HeadingTagLineText>}
        </div>
    );
}
